<h3>Ire Alert</h3>
<h4>{{ ireAlertService.type }}</h4>